const BRAND_GREEN = '#085e41'
const BRAND_GREEN_DARK = '#2D5A3D'

/**
 * Mail clients only render images over an absolute, publicly reachable URL, so the
 * logo and portrait always point at production even when the surrounding links are local.
 */
const LOGO_URL = 'https://glutenvrijadvies.nl/donker.png'
const PORTRAIT_URL = 'https://glutenvrijadvies.nl/images/esmee-borgts.jpg'

export const BRAND_SITE_URL = 'https://glutenvrijadvies.nl'

type BrandedEmailOptions = {
  /** Inner HTML of the message, already escaped. */
  body: string
  /** Hidden summary line shown by mail clients next to the subject. */
  preheader?: string
  /** Sign-off above the name, e.g. 'Warme groet,'. */
  closing?: string
  signature: string
  signatureRole: string
}

export function renderBrandedEmail({
  body,
  preheader,
  closing = 'Met gezonde groet,',
  signature,
  signatureRole,
}: BrandedEmailOptions) {
  return `<!DOCTYPE html>
<html lang="nl">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="color-scheme" content="light" />
    <title>Glutenvrijadvies.nl</title>
    <style>
      /* Apple Mail and Gmail turn bare domains and e-mail addresses into blue
         links, which is unreadable on the green header. */
      a[x-apple-data-detectors] {
        color: inherit !important;
        text-decoration: none !important;
        font-size: inherit !important;
        font-family: inherit !important;
        font-weight: inherit !important;
        line-height: inherit !important;
      }
      .brand-name,
      .brand-name a {
        color: #ffffff !important;
        text-decoration: none !important;
      }
      .footer-link,
      .footer-link a {
        color: ${BRAND_GREEN} !important;
        text-decoration: none !important;
      }
      .footer-contact,
      .footer-contact a {
        color: #6b7a72 !important;
        text-decoration: none !important;
      }
    </style>
  </head>
  <body style="margin:0;padding:0;background-color:#f4f6f4;">
    ${
      preheader
        ? `<div style="display:none;max-height:0;overflow:hidden;opacity:0;">${preheader}</div>`
        : ''
    }
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color:#f4f6f4;padding:24px 12px;">
      <tr>
        <td align="center">
          <table role="presentation" width="600" cellpadding="0" cellspacing="0" border="0" style="width:100%;max-width:600px;background-color:#ffffff;border-radius:16px;overflow:hidden;box-shadow:0 8px 30px rgba(8,94,65,0.08);">
            <tr>
              <td style="background:linear-gradient(90deg,${BRAND_GREEN},${BRAND_GREEN_DARK});background-color:${BRAND_GREEN};padding:28px 32px;" align="left">
                <table role="presentation" cellpadding="0" cellspacing="0" border="0">
                  <tr>
                    <td style="padding-right:12px;vertical-align:middle;">
                      <img src="${LOGO_URL}" width="44" height="44" alt="Glutenvrijadvies.nl" style="display:block;width:44px;height:44px;border:0;" />
                    </td>
                    <td class="brand-name" style="vertical-align:middle;">
                      <a href="${BRAND_SITE_URL}" style="font-family:Arial,Helvetica,sans-serif;font-size:19px;font-weight:bold;color:#ffffff;text-decoration:none;letter-spacing:-0.2px;">Glutenvrijadvies.nl</a>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding:32px;font-family:Arial,Helvetica,sans-serif;font-size:16px;line-height:26px;color:#33403a;">
                ${body}
                <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="margin:32px 0 0;">
                  <tr>
                    <td style="vertical-align:middle;font-family:Arial,Helvetica,sans-serif;font-size:16px;line-height:26px;color:#33403a;">
                      ${closing}<br />
                      <strong>${signature}</strong><br />
                      <span style="color:#6b7a72;">${signatureRole}</span>
                    </td>
                    <td width="72" style="padding-left:16px;vertical-align:middle;" align="right">
                      <img src="${PORTRAIT_URL}" width="72" height="72" alt="Esmée Borgts" style="display:block;width:72px;height:72px;border:0;border-radius:36px;" />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="background-color:#f4f6f4;padding:22px 32px;font-family:Arial,Helvetica,sans-serif;font-size:13px;line-height:20px;color:#6b7a72;" align="center">
                <span class="footer-link">
                  <a href="${BRAND_SITE_URL}" style="color:${BRAND_GREEN};font-weight:bold;text-decoration:none;">glutenvrijadvies.nl</a>
                </span>
                <br />
                <span class="footer-contact" style="color:#6b7a72;">info@glutenvrijadvies.nl &middot; 06 14 88 68 08</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`
}

export function renderEmailButton({ href, label }: { href: string; label: string }) {
  return `<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="margin:0 0 12px;">
    <tr>
      <td style="border-radius:8px;background-color:${BRAND_GREEN};">
        <a href="${href}" style="display:inline-block;padding:13px 22px;font-family:Arial,Helvetica,sans-serif;font-size:15px;font-weight:bold;color:#ffffff;text-decoration:none;border-radius:8px;">${label}</a>
      </td>
    </tr>
  </table>`
}
